export default "__VITE_ASSET__D2nR1zPp__"